<template>
    <b-container class="tab-content">
        <b-row>
            <!-- Logo Section -->
            <b-col
                cols="12"
                class="d-flex flex-column justify-content-center align-items-center mb-md-4"
            >
                <div class="logo-wrapper">
                    <b-skeleton width="200px" height="80px"></b-skeleton>
                </div>
            </b-col>

            <!-- Info Box Skeleton -->
            <div class="info-box mx-auto mt-3 mb-4 p-4" style="background-color: #f1f3f8; border-left: 6px solid #202c5a; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                <b-skeleton width="40%" height="30px" class="mb-3"></b-skeleton>
                <b-skeleton width="100%" height="15px" class="mb-2"></b-skeleton>
                <b-skeleton width="95%" height="15px" class="mb-3"></b-skeleton>
                <b-skeleton width="100%" height="15px" class="mb-2"></b-skeleton>
                <b-skeleton width="90%" height="15px" class="mb-3"></b-skeleton>
                <b-skeleton width="60%" height="15px"></b-skeleton>
            </div>

            <!-- Tabs Skeleton -->
            <b-tabs content-class="mt-3" class="w-100">
                <b-tab v-for="n in 3" :key="n">
                    <template #title>
                        <b-skeleton width="100px" height="20px"></b-skeleton>
                    </template>

                    <div class="row">
                        <!-- Left Column -->
                        <div class="col-md-6">
                            <b-skeleton width="40%" height="25px" class="mb-3"></b-skeleton>

                            <!-- Academic Year Section -->
                            <b-skeleton width="30%" height="22px" class="mb-3"></b-skeleton>
                            <div class="d-flex flex-column gap-2 mb-4">
                                <b-skeleton v-for="i in 3" :key="'year-'+i" width="60%" height="20px"></b-skeleton>
                            </div>

                            <!-- Registration Type -->
                            <b-skeleton width="35%" height="22px" class="mb-3"></b-skeleton>
                            <b-skeleton width="100%" height="38px" class="mb-3"></b-skeleton>
                            <ul style="list-style: none; padding-left: 0;">
                                <li v-for="i in 3" :key="'reg-'+i" class="mb-2">
                                    <b-skeleton width="70%" height="14px"></b-skeleton>
                                </li>
                            </ul>

                            <!-- Credits Section -->
                            <b-skeleton width="50%" height="22px" class="mb-3 mt-4"></b-skeleton>
                            <b-skeleton width="40%" height="16px" class="mb-2"></b-skeleton>
                            <div style="position: relative; height: 12px; background:#dee2e6; border-radius:6px;" class="mb-2">
                                <div style="position:absolute; left:0; top:0; height:100%; width:50%; background:#e0e0e0; border-radius:6px;"></div>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                                <b-skeleton width="35%" height="14px"></b-skeleton>
                                <b-skeleton width="30%" height="14px"></b-skeleton>
                            </div>
                            <b-skeleton width="30%" height="16px"></b-skeleton>

                            <!-- Housing Section -->
                            <b-skeleton width="40%" height="22px" class="mb-3 mt-4"></b-skeleton>
                            <b-skeleton width="100%" height="38px" class="mb-2"></b-skeleton>
                            <b-skeleton width="80%" height="14px" class="mb-3"></b-skeleton>

                            <!-- Metro Pass Section -->
                            <b-skeleton width="60%" height="22px" class="mb-3 mt-4"></b-skeleton>
                            <b-skeleton width="100%" height="38px" class="mb-2"></b-skeleton>
                            <b-skeleton width="70%" height="14px"></b-skeleton>
                        </div>

                        <!-- Right Column - Table -->
                        <div class="col-md-6">
                            <b-skeleton width="50%" height="22px" class="mb-3"></b-skeleton>

                            <table class="table table-bordered mt-3" style="font-size:0.95rem; background:#fff;">
                                <thead>
                                <tr>
                                    <th style="width: 60%;">
                                        <b-skeleton width="100%" height="18px"></b-skeleton>
                                    </th>
                                    <th style="width: 40%;">
                                        <b-skeleton width="80%" height="18px"></b-skeleton>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <b-skeleton width="90%" height="16px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="70%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b-skeleton width="85%" height="16px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="70%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="height: 20px;"></td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <b-skeleton width="30%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b-skeleton width="50%" height="16px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="60%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr v-for="i in 5" :key="'fee-'+i">
                                    <td>
                                        <b-skeleton width="70%" height="16px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="60%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b-skeleton width="80%" height="16px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="50%" height="16px"></b-skeleton>
                                    </td>
                                </tr>
                                <tr class="table-light">
                                    <td>
                                        <b-skeleton width="70%" height="18px"></b-skeleton>
                                    </td>
                                    <td>
                                        <b-skeleton width="80%" height="18px"></b-skeleton>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <b-skeleton width="90%" height="14px" class="mt-3"></b-skeleton>
                            <b-skeleton width="60%" height="14px" class="mt-2"></b-skeleton>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>

            <!-- Bottom Disclaimers Skeleton -->
            <div class="info-box mx-auto mt-5 mb-4 p-4" style="background-color: #f1f3f8; border-left: 6px solid #202c5a; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                <b-skeleton width="20%" height="18px" class="mb-3"></b-skeleton>
                <b-skeleton width="100%" height="14px" class="mb-2"></b-skeleton>
                <b-skeleton width="98%" height="14px" class="mb-2"></b-skeleton>
                <b-skeleton width="95%" height="14px" class="mb-2"></b-skeleton>
                <b-skeleton width="100%" height="14px" class="mb-2"></b-skeleton>
                <b-skeleton width="90%" height="14px"></b-skeleton>
            </div>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'TuitionCalculatorSkeleton'
}
</script>

<style scoped>
.logo-wrapper {
    margin-bottom: 20px;
}

.info-box {
    max-width: 1200px;
    width: 100%;
}

/* Tab stil düzenlemeleri */
.line-tabs >>> .nav-tabs {
    border-bottom: 2px solid #dee2e6;
}

.line-tabs >>> .nav-tabs .nav-link {
    border: none;
    border-bottom: 3px solid transparent;
    color: #6c757d;
}

.line-tabs >>> .nav-tabs .nav-link.active {
    border-bottom: 3px solid #dba631;
    color: #dba631;
    background: transparent;
}

/* Skeleton animasyon özelleştirmesi */
>>> .b-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s ease-in-out infinite;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
